import WhitneyLotteryDates from "../../../../src/components/WhitneyLotteryDates";
import * as React from 'react';
export default {
  WhitneyLotteryDates,
  React
};